import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Input,
  Checkbox,
  message,
  Spin,
  Collapse,
  Form,
  Switch,
  Modal,
  InputNumber,
} from "antd";
import { useNavigate } from "react-router-dom";
import { CALL_API } from "../../../Common/api";
import UIModal from "../../../Reusablecomponents/UIModal";
import { ReactComponent as Alert } from "../../../../src/assets/images/alert1.svg";
import { ReactComponent as Icon } from "../../../../src/assets/images/kpm.svg";
import { ReactComponent as RCopy } from "../../../../src/assets/images/RCopy.svg";
import { ReactComponent as GeoDelete } from "../../../../src/assets/images/GeoDelete.svg";
import { ReactComponent as GExport } from "../../../../src/assets/images/upload.svg";
import { ReactComponent as RDelete } from "../../../../src/assets/images/RDelete.svg";
import { ReactComponent as GKPM } from "../../../../src/assets/images/GKPM.svg";
import { ReactComponent as Drop } from "../../../../src/assets/images/drop.svg";
import { ReactComponent as GArrow } from "../../../../src/assets/images/GArrow.svg";
import { ReactComponent as Info } from "../../../../src/assets/images/mdi_information-outline.svg";
import { ReactComponent as Edit } from "../../../../src/assets/images/lucide_edit.svg";
import { ReactComponent as Delete } from "../../../../src/assets/images/mdi_delete-outline.svg";
import { ReactComponent as Notify } from "../../../../src/assets/images/lucide_bell.svg";
import { ReactComponent as RCreate } from "../../../../src/assets/images/RCreate.svg";
import { ReactComponent as RSearch } from "../../../../src/assets/images/RSearch.svg";

import GoogleMapComponent from "../../../Reusablecomponents/GoogleMapComponent";
import Styled from "styled-components";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { useSelector } from "react-redux";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ReactComponent as IntelSearch } from "../../../../src/assets/images/Frame 1233.svg";

dayjs.extend(utc);
dayjs.extend(timezone);

const Styledashboard = Styled.div`
.title {
font-weight: 600;
font-style: Semi Bold;
font-size: 18px;
color: #3D3D3D;
height: 17px;
width: 190px;
margin-top: 6px;
}
.container_for_header_subtwo {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap; /* allows wrapping instead of shrinking */
}

.container_for_header_subtwo1 {
  display: flex;
  justify-content: space-between; /* pushes Export icon to right end */
  align-items: center;
  width: 100%;
  gap: 16px;
}

.left-tools {
  display: flex;
  align-items: center;
  gap: 12px; /* spacing between Copy, Delete, and Search */
}

.left-section {
  display: flex;
  align-items: center;
  gap: 10px;
}
.route-toolbar {
  display: flex;
  justify-content: space-between;   /* LEFT ↔ RIGHT */
  align-items: center;
  width: 100%;
  margin-top: 10px;
  flex-wrap: wrap; /* makes it responsive */
}

.left-group {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.right-group {
  display: flex;
  align-items: center;
}

.custom-search {
  width: 650px;          /* responsive width */
  max-width: 100%;       /* prevents overflow */
  height: 36px;
  background: #F1F1F1;
  border-radius: 20px;
}
.container_for_header_subtwo > *:not(.select_icon_dropdown) {
  flex-shrink: 0; /* icons won't shrink */
}

    /* Style only the icon/button on the right */
  .green-search-icon .ant-input-search-button {
    background: #06ce06 !important;
    border-color: #06ce06 !important;
    color: white !important;
  }

  /* Make hover consistent */
  .green-search-icon .ant-input-search-button:hover {
    background: #05b605 !important;
    border-color: #05b605 !important;
  }
  /* Remove unwanted spacing before prefix icon */
  .custom-search .ant-input-prefix {
    margin-right: 6px !important; /* Keep small gap between icon & text */
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  /* Remove internal padding on input caused by prefix */
  .custom-search.ant-input-affix-wrapper {
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #00bc13 !important;
  border-color: #00bc13 !important;
}
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #00bc13 !important;
}
  .container_scrollable{
  height : calc(100vh - 140px) !important;
  overflow-y: scroll !important;
}
.scrollablle_container_two{
  height : calc(100vh - 340px) !important;
  overflow-y: scroll !important;
}
.icon-pressed {
  transform: scale(0.9);
  opacity: 0.7;
  transition: all 0.12s ease;
}
  .custom-search::placeholder {
  color: #5F6D8C !important; 
  font-size: 16px !important;  
  font-weight: 400 !important; 
}
  `;
const { Panel } = Collapse;
const Route = () => {
  const navigate = useNavigate();
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [companyList, setCompanyList] = useState([]);
  const [treeList, setTreeList] = useState([]);
  const [routeCompList, setRouteCompList] = useState([]);
  const [fenceList, setFenceList] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState({ guid: null, name: "" });
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);
  const [isNotifyModalVisible, setIsNotifyModalVisible] = useState(false);
  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [departureDelay, setDepartureDelay] = useState(0);
  const [arrivalDelay, setArrivalDelay] = useState(0);
  const [lateDepartureWarning, setLateDepartureWarning] = useState(false);
  const [lateDepartureAlarm, setLateDepartureAlarm] = useState(false);
  const [lateArrivalWarning, setLateArrivalWarning] = useState(false);
  const [lateArrivalAlarm, setLateArrivalAlarm] = useState(false);
  const [deviationAlarm, setDeviationAlarm] = useState(false);
  const [routesMap, setRoutesMap] = useState([]);
  const [copyTargetAgent, setCopyTargetAgent] = useState({
    guid: null,
    name: "",
  });
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("ROUTE", "CR"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("ROUTE", "UR"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("ROUTE", "DR"),
    [reduxPermissions],
  );
  const copyAllowed = useMemo(
    () => hasPermission("ROUTE", "CYR"),
    [reduxPermissions],
  );
    const exportAllowed = useMemo(
    () => hasPermission("ROUTE", "EX"),
    [reduxPermissions],
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  function filterTreeNodes(nodes, search) {
    if (!search || search.trim() === "") return nodes;

    const lower = search.toLowerCase();

    return nodes
      .map((node) => {
        const nameMatch = node.FName?.toLowerCase().includes(lower);

        // recursively check children
        const filteredChildren = Array.isArray(node.FChild)
          ? filterTreeNodes(node.FChild, search)
          : [];

        if (nameMatch || filteredChildren.length > 0) {
          return {
            ...node,
            FChild: filteredChildren,
          };
        }

        return null;
      })
      .filter(Boolean);
  }

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedKeys(fenceList?.map((item) => item.FGUID));
    } else {
      setSelectedKeys([]);
    }
  };

  const handleCheckboxChange = (id) => {
    if (selectedKeys.includes(id)) {
      setSelectedKeys(selectedKeys.filter((key) => key !== id));
    } else {
      setSelectedKeys([...selectedKeys, id]);
    }
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllCompany();
  }, []);

  const getFenceTree = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "geoFence/tree-without-fence", {
        FAgentGUID: userInfo?.ECTSCompId || "",
      });
      setTreeList(data);
    } catch (error) {
      console.error("[getFenceTree] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getFenceTree();
  }, []);
  const [search, setSearch] = useState("");
  const [search1, setSearch1] = useState("");

  const handleSearch = (val) => {
    setSearch(val);
    setCurrentPage(1); // reset pagination
  };
  const fetchAllRoutes = useCallback(async () => {
    const agentGUID = selectedAgent.guid || userInfo?.ECTSCompId;
    if (!agentGUID) return;

    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "routes/routeslist", {
        FAgentGUID: agentGUID,
        FIsAll: 1,
        FKey: search,
        FPageSize: pageSize,
        FPageIndex: currentPage,
      });
      setFenceList(data?.routes);
      setTotal(data?.totalCount);
    } catch (error) {
      console.error("[fetchAllRoutes] error:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedAgent.guid, userInfo?.ECTSCompId, pageSize, currentPage, search]); // dependency

  const fetchRouteCompList = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "routes/routeCompList", {
        FAgentGUID: userInfo?.ECTSCompId,
      });
      setRouteCompList(data);
    } catch (error) {
      console.error("[fetchAllRoutes] error:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedAgent.guid]); // dependency

  useEffect(() => {
    fetchAllRoutes();
  }, [fetchAllRoutes]);

  useEffect(() => {
    fetchRouteCompList();
  }, []);

  const handleDelete = async () => {
    try {
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `routes/delete-routes`,
        {
          FGUIDs: selectedKeys.join(","),
        },
      );
      if (ResponseCode === 200) {
        message.success("Route(s) deleted successfully!");
        setSelectedKeys([]);
        fetchAllRoutes();
      } else if (ResponseCode === 400) {
        message.success(
          "This route cannot be deleted because it is linked to an active trip.",
        );
        setSelectedKeys([]);
        fetchAllRoutes();
      } else {
        message.error("Failed to delete Route(s).");
      }
    } catch (error) {
      console.error("Error deleting Route:", error);
      message.error("An error occurred while deleting the route(s).");
    } finally {
      setLoading(false);
      setIsDeleteModalVisible(false); // Close the modal
    }
  };

  const handleCopy = async () => {
    try {
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `routes/route-copy`,
        {
          FGUIDs: selectedKeys.join(","),
          FAgentGUIDs: copyTargetAgent.guid,
        },
      );
      if (ResponseCode === 200) {
        message.success("Route(s) copied successfully!");
        setSelectedKeys([]);
        fetchAllRoutes();
        setIsCopyModalVisible(false);
      } else {
        message.error("Failed to copy Route(s).");
      }
    } catch (error) {
      console.error("Error copying Route:", error);
      message.error("An error occurred while copying the route(s).");
    } finally {
      setLoading(false);
      setIsCopyModalVisible(false); // Close the modal
    }
  };

  const routeMap = async (FGUID) => {
    try {
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `routes/route-details`,
        {
          FGUID: FGUID,
          FTokenID: "05463e39-8da7-479f-9377-c990bd17f76c",
        },
      );
      setRoutesMap(data?.route.Table[0]);
    } catch (error) {
      console.error("Error deleting Route:", error);
    } finally {
      setLoading(false);
    }
  };

  const configAlarm = async (FGUID) => {
    setLoading(true);
    try {
      const payload = {
        FRouteGUID: FGUID,
        FLdwTime: departureDelay,
        FLdw: lateDepartureWarning ? 1 : 0,
        FLda: lateDepartureAlarm ? 1 : 0,
        FLawTime: arrivalDelay,
        FLaw: lateArrivalWarning ? 1 : 0,
        FLaa: lateArrivalAlarm ? 1 : 0,
        FShiftingAlarm: deviationAlarm ? 1 : 0,
        FRoadWidth: 50, // or dynamic value if applicable
      };

      const { data, ResponseCode } = await CALL_API(
        "POST",
        `routes/alarm-config`,
        payload,
      );

      if (ResponseCode === 200) {
        message.success("Configuration saved successfully");
        setIsNotifyModalVisible(false);
      } else {
        message.error("Failed to save configuration");
      }
    } catch (error) {
      console.error("Error configuring alarm:", error);
      message.error("An error occurred while saving");
    } finally {
      setLoading(false);
    }
  };
  const handleReset = () => {
    setDepartureDelay(0);
    setArrivalDelay(0);
    setLateDepartureWarning(false);
    setLateDepartureAlarm(false);
    setLateArrivalWarning(false);
    setLateArrivalAlarm(false);
    setDeviationAlarm(false);
  };
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });
  const columns = [
    {
      title: (
        <Checkbox
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => handleSelectAll(e.target.checked)}
          checked={
            fenceList.length > 0 && selectedKeys.length === fenceList.length
          }
          indeterminate={
            selectedKeys.length > 0 && selectedKeys.length < fenceList.length
          }
        />
      ),
      dataIndex: "checkbox",
      key: "checkbox",
      width: "5%",
      render: (_, record) => (
        <Checkbox
          checked={selectedKeys.includes(record.FGUID)}
          onClick={(e) => e.stopPropagation()}
          onChange={() => handleCheckboxChange(record.FGUID)}
        />
      ),
    },
    {
      title: "Index",
      dataIndex: "RowNo",
      key: "RowNo",
      width: "10%",
    },
    {
      title: "Operation",
      key: "operation",
      // width: "20%",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            border: "1px solid #d9d9d9",
            borderRadius: "4px",
            overflow: "hidden",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Tooltip title={!createAllowed ? "No permission" : ""}>
            <Edit
              style={{ cursor: updateAllowed ? "pointer" : "not-allowed" }}
              onClick={(e) => {
                if (!updateAllowed) return;
                e.stopPropagation(); // Prevent row click
                routeMap(record.FGUID);
                navigate("/RouteDetails", {
                  state: {
                    ...record,
                    mode: "edit",
                    FGUID: record.FGUID,
                  },
                });
              }}
            />
          </Tooltip>

          <Notify
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setIsNotifyModalVisible(true);
            }}
          />
          <Tooltip title={!deleteAllowed ? "No permission" : ""}>
            <Delete
              style={{ cursor: deleteAllowed ? "pointer" : "not-allowed" }}
              onClick={(e) => {
                if (!deleteAllowed) return;
                e.stopPropagation();
                setIsDeleteModalVisible(true);
              }}
            />
          </Tooltip>
          <Info
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setExpandedRowKey(
                expandedRowKey === record.FGUID ? null : record.FGUID,
              );
              routeMap(record.FGUID);
            }}
          />
        </div>
      ),
    },
    {
      title: "Route Name",
      dataIndex: "FName",
      key: "FName",
      width: "20%",
      sorter: (a, b) => (a.FName || "").localeCompare(b.FName || ""),
      sortOrder: tableSort.field === "FName" ? tableSort.order : null,
    },
    {
      title: "Route Code",
      dataIndex: "FCode",
      key: "FCode",
      width: "15%",
      sorter: (a, b) => (a.FCode || "").localeCompare(b.FCode || ""),
      sortOrder: tableSort.field === "FCode" ? tableSort.order : null,
    },
    {
      title: "Transport Time",
      dataIndex: "FDuration",
      key: "FDuration",
      width: "20%",
      sorter: (a, b) => (a.FDuration || "").localeCompare(b.FDuration || ""),
      sortOrder: tableSort.field === "FDuration" ? tableSort.order : null,
      render: (duration) => {
        if (!duration && duration !== 0) return "-";
        const hours = duration / 3600;
        return `${hours} hours`;
      },
    },
    {
      title: "Route Type",
      dataIndex: "FRouteType",
      key: "FRouteType",
      width: "20%",
      sorter: (a, b) => (a.FRouteType || "").localeCompare(b.FRouteType || ""),
      sortOrder: tableSort.field === "FRouteType" ? tableSort.order : null,
      render: (value) => (value === 0 ? "Fixed Route" : "Streamlined Route"),
    },
  ];
  function getAllPanelKeys(nodes) {
    let keys = [];
    nodes.forEach((node) => {
      if (Array.isArray(node.FChild) && node.FChild.length > 0) {
        keys.push(node.FGUID);
        keys = keys.concat(getAllPanelKeys(node.FChild));
      }
    });
    return keys;
  }
  const allPanelKeys = Array.isArray(routeCompList)
    ? getAllPanelKeys(routeCompList)
    : getAllPanelKeys([routeCompList]);
  const findActivePanels = (nodes, selectedGuid, path = []) => {
    for (let node of nodes) {
      if (node.FGUID === selectedGuid) {
        return path; // Returning the path up to this node
      }
      if (node.FChild && node.FChild.length > 0) {
        const result = findActivePanels(node.FChild, selectedGuid, [
          ...path,
          node.FGUID,
        ]);
        if (result) return result;
      }
    }
    return null;
  };

  const activePanels = findActivePanels(treeList, selectedAgent.guid) || [];
  // Recursive panel renderer
  const renderTreePanels = (
    nodes,
    setSelectedAgent,
    level = 0,
    activePanels = [],
    mode = "main",
    parentFGUID = null,
  ) =>
    nodes.map((node) => {
      const isSelected =
        mode === "copy"
          ? copyTargetAgent.guid === (parentFGUID || node.FGUID) &&
            copyTargetAgent.name === node.FName
          : selectedAgent.guid === node.FGUID;

      const header = (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: level === 0 ? 600 : 500,
            fontSize: level === 0 ? "16px" : "14px",
            color: isSelected ? "#2C963D" : "#3D3D3D",
            background: isSelected
              ? "#D4F5D4"
              : level === 0
                ? "#E8FFEC"
                : "#F5FFF8",
            padding: "4px 8px",
            borderRadius: 6,
            border: isSelected ? "2px solid #2C963D" : "1px solid transparent",
            cursor: "pointer",
          }}
          onClick={() => {
            if (mode === "copy") {
              setCopyTargetAgent({
                guid: parentFGUID || node.FGUID,
                name: node.FName,
              });
            } else {
              setSelectedAgent({
                guid: node.FGUID,
                name: node.FName,
              });
            }
          }}
        >
          {level === 0 ? (
            <GKPM style={{ marginRight: 8, flexShrink: 0 }} />
          ) : (
            <Drop style={{ marginRight: 8, flexShrink: 0 }} />
          )}
          {node.FName}
        </span>
      );

      if (Array.isArray(node.FChild) && node.FChild.length > 0) {
        return (
          <Panel key={node.FGUID} header={header} style={{ border: "none" }}>
            <Collapse
              bordered={false}
              expandIconPosition="end"
              activeKey={activePanels}
              expandIcon={({ isActive }) => (
                <GArrow
                  size={18}
                  style={{
                    transform: isActive ? "rotate(0deg)" : "rotate(180deg)",
                    transition: "transform 0.2s",
                  }}
                />
              )}
            >
              {renderTreePanels(
                node.FChild,
                setSelectedAgent,
                level + 1,
                activePanels,
                mode,
                node.FGUID, // pass parentFGUID
              )}
            </Collapse>
          </Panel>
        );
      }

      // Leaf node
      return (
        <div
          key={node.FGUID}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "4px 0",
            cursor: "pointer",
            marginLeft: level * 20,
            fontWeight: isSelected ? 600 : 400,
            color: isSelected ? "#2C963D" : "#555",
            background: isSelected ? "#D4F5D4" : undefined,
            borderRadius: isSelected ? 6 : undefined,
            border: isSelected ? "2px solid #2C963D" : undefined,
          }}
          onClick={() => {
            if (mode === "copy") {
              setCopyTargetAgent({
                guid: parentFGUID || node.FGUID,
                name: node.FName,
              });
            } else {
              setSelectedAgent({
                guid: node.FGUID,
                name: node.FName,
              });
            }
          }}
        >
          <Drop style={{ marginRight: 8 }} />
          {node.FName}
        </div>
      );
    });

  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API("POST", `routes/routeslist`, {
        FAgentGUID: selectedAgent.guid || userInfo?.ECTSCompId,
        FIsAll: 1,
        FKey: "",
        FPageSize: total,
        FPageIndex: currentPage,
      });

      if (data?.routes?.length > 0) {
        setCSVList(
          data?.routes.map((item) => ({
            "Route Name": item.FName || "-",
            "Route Code": item.FCode || "-",
            "Transport Time":
              item.FDuration || item.FDuration === 0
                ? `${item.FDuration / 3600} hours`
                : "-",
            "Route Type":
              item.FRouteType === 0
                ? "Fixed Route"
                : item.FRouteType === 1
                  ? "Streamlined Route"
                  : "",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };
  const [pressed, setPressed] = useState(false);

  const handleClick = () => {
    setPressed(true);
    setTimeout(() => setPressed(false), 150);
    navigate("/RouteDetails", { state: { mode: "add" } });
  };

  function getCompanyNameByFGUID(nodes, guid) {
    for (const node of nodes) {
      if (node.FGUID === guid) return node.FName;
      if (Array.isArray(node.FChild)) {
        const found = getCompanyNameByFGUID(node.FChild, guid);
        if (found) return found;
      }
    }
    return "";
  }

  return (
    <Styledashboard>
      <div style={{ padding: "16px", background: "#f0f2f5" }}>
        <Row gutter={[0, 16]} style={{ margin: 0 }}>
          {/* Left White Box */}
          {userInfo?.MCID === 59 && userInfo?.SYSADM === true && (
            <Col
              style={{
                flex: "0 0 350px",
                maxWidth: 350,
                minWidth: 350,
                paddingRight: 0,
                paddingLeft: 0,
              }}
            >
              {" "}
              <Card
                className="container_scrollable"
                style={{
                  borderRadius: "12px",
                  height: "100%",
                  width: "100%",
                  marginRight: "20px",
                }}
              >
                <div>
                  {/* Search bar */}
                  <Input
                    className="custom-search"
                    allowClear
                    placeholder="Enter keywords"
                    value={search1}
                    prefix={
                      <IntelSearch
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    }
                    onChange={(e) => setSearch1(e.target.value)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  />

                  <br />
                  {/* Dropdown items */}
                  <Collapse
                    bordered={false}
                    expandIconPosition="end"
                    activeKey={allPanelKeys}
                    expandIcon={({ isActive }) => (
                      <GArrow
                        size={18}
                        style={{
                          transform: isActive
                            ? "rotate(0deg)"
                            : "rotate(180deg)",
                          transition: "transform 0.2s",
                        }}
                      />
                    )}
                  >
                    {Array.isArray(routeCompList)
                      ? renderTreePanels(
                          filterTreeNodes(routeCompList, search1),
                          setSelectedAgent,
                          0,
                          allPanelKeys,
                        )
                      : renderTreePanels(
                          filterTreeNodes(routeCompList, search1),
                          setSelectedAgent,
                          0,
                          allPanelKeys,
                        )}
                  </Collapse>
                </div>
              </Card>
            </Col>
          )}
          {/* Right White Box */}
          <Col
            style={{ flex: 1, minWidth: 0, paddingLeft: 15, paddingRight: 0 }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <Card
                style={{
                  borderRadius: "12px",
                  height: "100%",
                  width: "100%", // lock width to col size
                  overflow: "hidden", // prevent overflow messing layout
                }}
              >
                <div className="container_for_header_subtwo1">
                  <div className="left-section">
                    <Icon />
                    <p className="title">{userInfo?.COMPNAME}</p>
                  </div>
                  <Tooltip title={!createAllowed ? "No permission" : ""}>
                    <RCreate
                      className={pressed ? "icon-pressed" : ""}
                      style={{
                        cursor: createAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!createAllowed) return;
                        handleClick();
                      }}
                    />
                  </Tooltip>
                </div>
                <br />
                <div className="route-toolbar">
                  <div className="left-group">
                    <RDelete
                      style={{
                        cursor: deleteAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!deleteAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a route before attempting to delete.",
                          );
                          return;
                        }
                        setIsDeleteModalVisible(true);
                      }}
                    />
                    <RCopy
                      style={{
                        cursor: copyAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!copyAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a route before attempting to copy.",
                          );
                          return;
                        }
                        setIsCopyModalVisible(true);
                      }}
                    />

                    <Input
                      className="custom-search"
                      placeholder="Search"
                      allowClear
                      prefix={
                        <RSearch
                          style={{ marginLeft: "10px", cursor: "pointer" }}
                        />
                      }
                      value={search}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>

                  <div className="right-group">
                    <Spin spinning={CSVLoader}>
                      <GExport
                        style={{ cursor: "pointer" }}
                        onClick={()=>{
                          if (!exportAllowed) return;
                          prepareCSV()}}
                      />
                    </Spin>

                    <CSVLink
                      data={CSVList}
                      filename={"Route.csv"}
                      asyncOnClick={true}
                      ref={csvLinkEl}
                    />
                  </div>
                </div>
                {/* Table with scroll */}
                <div className="scrollablle_container_two">
                  <Spin spinning={loading}>
                    {total > 0 && (
                      <StyledTable
                        className="mt-4"
                        dataSource={fenceList}
                        columns={columns}
                        pagination={false}
                        rowKey="FGUID"
                        onChange={(pagination, filters, sorter) => {
                          setTableSort({
                            field: sorter.field,
                            order: sorter.order,
                          });
                        }}
                        expandable={{
                          expandedRowKeys: expandedRowKey
                            ? [expandedRowKey]
                            : [],
                          onExpand: (expanded, record) => {
                            setExpandedRowKey(expanded ? record.FGUID : null);
                          },
                          expandedRowRender: (record) => (
                            <div style={{ height: "100%", width: "100%" }}>
                              <GoogleMapComponent
                                routeData={routesMap}
                                mapSize="small"
                              />
                            </div>
                          ),
                          expandIcon: () => <span />,
                        }}
                      />
                    )}
                    <ReusablePagination
                      pageSize={pageSize}
                      handlePageSizeChange={handlePageSizeChange}
                      currentPage={currentPage}
                      total={total}
                      handlePageChange={handlePageChange}
                    />
                  </Spin>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <GeoDelete />
          <h3>Delete Route?</h3>
          <p>
            This action will permanently delete the selected Route. Do you want
            to proceed?
          </p>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleDelete} // Call the delete function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsDeleteModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <Modal
        title="Alarm Configuration"
        open={isNotifyModalVisible}
        onCancel={() => setIsNotifyModalVisible(false)}
        footer={[
          <Buttontransparent
            key="reset"
            onClick={handleReset}
            disabled={loading}
          >
            Reset
          </Buttontransparent>,
          <ButtonFilled
            key="save"
            type="primary"
            onClick={configAlarm}
            loading={loading}
          >
            Save
          </ButtonFilled>,
        ]}
        width={500}
      >
        <Form layout="horizontal">
          <Form.Item label="Departure delay warning time" required>
            <InputNumber
              min={0}
              value={departureDelay}
              onChange={(value) => setDepartureDelay(value)}
              addonAfter="Min"
              style={{ width: "50%" }}
            />
          </Form.Item>
          <Form.Item label="Arrival delay warning time" required>
            <InputNumber
              min={0}
              value={arrivalDelay}
              onChange={(value) => setArrivalDelay(value)}
              addonAfter="Min"
              style={{ width: "50%" }}
            />
          </Form.Item>

          <Form.Item label="Late departure warning">
            <Switch
              checked={lateDepartureWarning}
              onChange={(checked) => setLateDepartureWarning(checked)}
            />
          </Form.Item>

          <Form.Item label="Late departure alarm">
            <Switch
              checked={lateDepartureAlarm}
              onChange={(checked) => setLateDepartureAlarm(checked)}
            />
          </Form.Item>

          <Form.Item label="Late arrival warning">
            <Switch
              checked={lateArrivalWarning}
              onChange={(checked) => setLateArrivalWarning(checked)}
            />
          </Form.Item>

          <Form.Item label="Late arrival alarm">
            <Switch
              checked={lateArrivalAlarm}
              onChange={(checked) => setLateArrivalAlarm(checked)}
            />
          </Form.Item>

          <Form.Item label="Deviation alarm">
            <Switch
              checked={deviationAlarm}
              onChange={(checked) => setDeviationAlarm(checked)}
            />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Copy Route"
        open={isCopyModalVisible}
        onCancel={() => setIsCopyModalVisible(false)}
        footer={[
          <Buttontransparent onClick={() => setIsCopyModalVisible(false)}>
            Cancel
          </Buttontransparent>,
          <ButtonFilled key="save" type="primary" onClick={handleCopy}>
            Copy
          </ButtonFilled>,
        ]}
        width={500} // adjust modal size
      >
        <Card style={{ borderRadius: "12px", height: "100%" }}>
          <div>
            <b>Choose where you want to paste route</b>
            {copyTargetAgent.guid && copyTargetAgent.name && (
              <div style={{ marginTop: 16, fontWeight: 500, color: "#2C963D" }}>
                Paste the route to:{" "}
                <span style={{ color: "#222" }}>
                  {getCompanyNameByFGUID(treeList, copyTargetAgent.guid)} →
                  {copyTargetAgent.name || ""}
                </span>
              </div>
            )}
            <br />

            {/* Dropdown items */}
            {loading ? (
              <Spin />
            ) : (
              <Collapse
                bordered={false}
                expandIconPosition="end"
                expandIcon={({ isActive }) => (
                  <GArrow
                    size={18}
                    style={{
                      transform: isActive ? "rotate(0deg)" : "rotate(180deg)",
                      transition: "transform 0.2s",
                    }}
                  />
                )}
              >
                {Array.isArray(treeList)
                  ? renderTreePanels(
                      treeList,
                      setCopyTargetAgent,
                      0,
                      [],
                      "copy",
                    )
                  : renderTreePanels(
                      [treeList],
                      setCopyTargetAgent,
                      0,
                      [],
                      "copy",
                    )}
              </Collapse>
            )}
          </div>
        </Card>
      </Modal>
    </Styledashboard>
  );
};

export default Route;
